/**
 * An organization the user can choose from after a "bridge" login (organizationId empty), see
 * {@link AuthenticationLoginResponseModel.entiSelezionabili}.
 */
export class EnteSelezionabile {
    id: string = ''
    nome: string = ''
}

/**
 * Represents the authentication login response model.

 * This interface defines the structure of the response data received after a successful login.

 * @interface AuthenticationLoginResponseModel
 */
export class AuthenticationLoginResponseModel {
    /**
     * The access token.
     */
    token: string = ''

    /**
     * The expiration date of the access token.
     */
    scadenzaToken: string = ''

    /**
     * The refresh token.
     */
    refreshToken: string = ''

    /**
     * The expiration date of the refresh token.
     */
    scadenzaRefreshToken: string = ''

    /**
     * Organization embedded in the token. Null/empty-guid when the login happened without a known
     * organization (admin/operator profile from a generic URL): in that case the client must show
     * {@link entiSelezionabili} and confirm the choice via Authentication/SelezionaEnte before calling
     * any per-organization API.
     */
    organizationId: string | null = null

    /**
     * Organizations the user can pick from, populated only when organizationId is empty/null.
     */
    entiSelezionabili: EnteSelezionabile[] | null = null

    /**
     * True se l'utente è SuperAmministratore (può creare nuovi enti). Nel login "ponte" l'utente locale
     * non è ancora caricato, quindi il flag deve arrivare nella risposta di login.
     * TODO(backend): valorizzare dal flag `SuperAmministratore` di AccountUtenti.
     */
    superAmministratore: boolean | null = null
}

/** All-zero GUID: the sentinel value the backend uses for "no organization selected yet". */
export const EMPTY_ORGANIZATION_ID = '00000000-0000-0000-0000-000000000000'

/** True when the login response indicates the client must show the organization picker. */
export function richiedeSelezioneEnte(authResult: AuthenticationLoginResponseModel | null): boolean {
    if (authResult == null) return false
    return !authResult.organizationId || authResult.organizationId === EMPTY_ORGANIZATION_ID
}
